import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminAuthState {
  token: string | null;
  user: { id: string; email: string; name: string; isAdmin: boolean } | null;
  setAuth: (token: string, user: { id: string; email: string; name: string; isAdmin: boolean }) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAdminAuthStore = create<AdminAuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      logout: () => set({ token: null, user: null }),
      isAuthenticated: () => !!get().token && !!get().user?.isAdmin,
    }),
    {
      name: 'admin-auth-storage',
    }
  )
);
